import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/facebook.png'
import _imports_1 from '../assets/whatsapp.png'
import _imports_2 from '../assets/Instagram.png'


const _hoisted_1 = { class: "contact-page" }
const _hoisted_2 = { class: "contact-header" }
const _hoisted_3 = { class: "contact-container" }
const _hoisted_4 = { class: "contact-info" }
const _hoisted_5 = { class: "contact-item" }
const _hoisted_6 = { class: "contact-details" }
const _hoisted_7 = { class: "contact-item" }
const _hoisted_8 = { class: "contact-details" }
const _hoisted_9 = { class: "contact-item" }
const _hoisted_10 = { class: "contact-details" }
const _hoisted_11 = { class: "contact-item" }
const _hoisted_12 = { class: "contact-details" }
const _hoisted_13 = { class: "contact-map" }
const _hoisted_14 = {
  href: "https://www.google.com/maps/dir//DR+MOTOR+LTD,+Kwun+Tong+Promenade,+Kwun+Tong,+Hong+Kong",
  target: "_blank",
  class: "navigate-button"
}
const _hoisted_15 = { class: "social-media-section" }
const _hoisted_16 = { class: "social-media-icons" }
const _hoisted_17 = ["title"]
const _hoisted_18 = ["alt"]
const _hoisted_19 = ["title"]
const _hoisted_20 = ["alt"]
const _hoisted_21 = ["title"]
const _hoisted_22 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.t('contactTitle')), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.t('contactDesc')), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "contact-icon phone-icon" }, "📞", -1)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.t('phone')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.t('phone1')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "contact-icon wechat-icon" }, "💬", -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.t('whatsappWechat')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.t('phone2')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "contact-icon email-icon" }, "📧", -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.t('emailLabel')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.t('email')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "contact-icon address-icon" }, "📍", -1)),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.t('addressLabel')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.t('address')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[4] || (_cache[4] = _createElementVNode("iframe", {
          width: "100%",
          height: "100%",
          frameborder: "0",
          loading: "lazy",
          allowfullscreen: "",
          "aria-hidden": "false",
          tabindex: "0",
          src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.0847162179427!2d114.23822611526445!3d22.311846648358146!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340400634d6b136f%3A0xc80992f7c9449a12!2sDR%20MOTOR%20LTD!5e0!3m2!1szh-CN!2shk!4v1623456789012",
          style: {"border":"0px"}
        }, null, -1)),
        _createElementVNode("a", _hoisted_14, _toDisplayString(_ctx.t('startNavigation')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.t('followUs')), 1),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("a", {
          href: "https://www.facebook.com/profile.php?id=61577205355724",
          target: "_blank",
          class: "social-icon",
          title: _ctx.t('facebook')
        }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: _ctx.t('facebook')
          }, null, 8, _hoisted_18)
        ], 8, _hoisted_17),
        _createElementVNode("a", {
          href: "whatsapp://send?phone=+85266860815",
          target: "_blank",
          class: "social-icon",
          title: _ctx.t('whatsapp')
        }, [
          _createElementVNode("img", {
            src: _imports_1,
            alt: _ctx.t('whatsapp')
          }, null, 8, _hoisted_20)
        ], 8, _hoisted_19),
        _createElementVNode("a", {
          href: "https://www.instagram.com/dr_moto_ev_hk_ltd/",
          target: "_blank",
          class: "social-icon",
          title: _ctx.t('instagram')
        }, [
          _createElementVNode("img", {
            src: _imports_2,
            alt: _ctx.t('instagram')
          }, null, 8, _hoisted_22)
        ], 8, _hoisted_21)
      ])
    ])
  ]))
}